import { render, staticRenderFns } from "./SiteManagement.vue?vue&type=template&id=fa4924dc&scoped=true"
import script from "./SiteManagement.vue?vue&type=script&lang=js"
export * from "./SiteManagement.vue?vue&type=script&lang=js"
import style0 from "./SiteManagement.vue?vue&type=style&index=0&id=fa4924dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4924dc",
  null
  
)

export default component.exports